module.exports = __webpack_public_path__ + "static/media/square-shapes-2.fd3d631c.svg";